import React, { useEffect, useState } from "react";
import axios from "axios";
import { set, useForm } from "react-hook-form";
import { useOutletContext, useNavigate } from "react-router-dom";
import $ from "jquery";
import Select from "react-select";
import toastr from "../../../utils/toast";

function AddContract({ onClose, updata, contract_id }) {
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    unregister,
    clearErrors,
    formState: { errors },
  } = useForm();
  const [data, setData] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [clienttypes, setClienttypes] = useState([]);
  const [entities, setEntities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [noPoachClause, setnoPoachClause] = useState(null);
  const [currency, setCurrencies] = useState([]);
  const [retainertype, setRetainerTypes] = useState([]);
  const [selectretainertype, setselectretainertype] = useState(null);
  const [clienttype, setClientType] = useState(null);
  const [count, setCount] = useState(3);
  const [feetype, setFeeType] = useState("RoleWise");
  const [roleNumber, setroleNumber] = useState("single-condition");
  const [feecaptype, setFeeCapType] = useState(null);
  const [terminationClause, setTerminationClause] = useState(null);
  const [nopoach, setNoPoach] = useState(null);
  const [extraInputs, setExtraInputs] = useState([]);
  const [showModal, setShowModal] = useState(true);
  const [parsedData, setParsedData] = useState([]);
  const [rows, setRows] = useState([0, 1, 2]); // default 3 rows
  const [SelectedCountry, setSelectedCountry] = useState([]);
  const [SelectedRegion, setSelectedRegion] = useState([]);
  const [disableExpense, setDisableExpense] = useState(false);
  const splitNum = watch("split_num");
  const clientRetainerTypeId = watch("clientretainertype_id");
  const [compensationComponents, setCompensationComponents] = useState([]);
  const [selectedCompensationComponents, setSelectedCompensationComponents] = useState([1, 2]);
  const handleAddMore = () => {
    setRows((prev) => [...prev, prev.length]);
  };

  const peVcReferredOption = watch("peVcReferredOption");

  const handleRadioChange = () => {
    setDisableExpense((prev) => !prev);

    if (!disableExpense) {
      // Clear value and validation if disabling
      setValue("expensePercent", "");
      clearErrors("expensePercent");
    }
  };

  const parsedComponentToCode = {
    fixed_pay: "FIXED_BASE",
    performance_bonus: "VARIABLE_BONUS",
    guaranteed_bonus: "GUARANTEED_BONUS",
    joining_bonus: "JOINING_BONUS",
    allowances: "ALLOWANCES",
    rsu: "RSU",
    esop: "ESOP",
  };

  // Fetch dropdown data once on mount
  useEffect(() => {
    async function fetchAllDropdownData() {
      setGlobalLoading(false); //  Show loader before API call
      try {
        const res = await axios.get(`${API_BASE_URL}/contracts/contractd`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = res.data;
        setValue("agn", data.new_agn);
        setData(data);
        setCompanies(data.companies || []);
        setClienttypes(data.clienttypes || []);
        setEntities(data.entities || []);
        setCountries(data.countries || []);
        setRegions(data.regions || []);
        setCurrencies(data.currencies || []);
        setRetainerTypes(data.retainertypes || []);
        setValue("currency_id", data.currencies[0].id);
        setCompensationComponents(data.compensationComponents || []);
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    }
    fetchAllDropdownData();
  }, []);

  useEffect(() => {
    let parsed = updata;
    if (typeof updata == "string") {
      parsed = JSON.parse(updata);
    }

    if (!parsed || Object.keys(parsed).length === 0) {
      return; // ⛔ stop if parsed is empty
    }
    console.log(parsed);
    setParsedData(parsed);
    setValue("contract_name", parsed.contract_name);

    if (parsed.Client_signature_present == "Yes") {
      setValue("contractSigned", 1);
    }
    setValue("contractdate", parsed.contractstart);
    setValue("contractstart", parsed.contractstart);
    setValue("contractend", parsed.contractend);
    setValue("split_num", parsed.split_num);
    setCount(parsed.split_num);
    for (let i = 1; i <= parsed.split_num; i++) {
      let value = parsed["p_scnt_" + i];
      if (
        typeof value === "float" ||
        parsed["p_scnt_" + i].toString().length < 3
      ) {
        value = parsed["p_scnt_" + i] + "%";
      }
      setValue(`p_scnt_${i}`, value);
      setValue(`p_scnt_note_${i}`, parsed["p_scnt_note_" + i]);
    }

    setValue("fee_type", parsed.fee_type);
    setFeeType(parsed.fee_type);
    setValue("type_one_fee", parsed.Role_wise_fee_details || 0);
    const fee = Number(parsed.Role_wise_fee_details) || 0;
    setValue("type_one_fee", fee < 100 ? `${fee}%` : fee);
    setValue("expensePercent", parsed.Expense_percent ? parsed.Expense_percent + "%" : "0%");
    currency.forEach((currency) => {
      if (currency.name == parsed.Amount_accepted_in_currency) {
        setValue("currency_id", currency.id);
      }
    });
    setValue("fee_cap_type", parsed.fee_cap_type || "NA");
    setFeeCapType(parsed.fee_cap_type || "NA");
    setValue("fee_cap_amount", parsed.fee_cap);
    setValue("base_fee_cap_amount", parsed.fee_cap);
    setValue("candidateRegPeriod", parsed.Candidate_resignation_replacement_period + " months");
    setValue("candidateProfileValidity", parsed.Candidate_profile_validity + " months");
    setValue("invoice_due_in", parsed.Invoice_due && parsed.Invoice_due !== "" ? parsed.Invoice_due : 30);
    setValue("profileValidityFee", parsed.Profile_validity_fee);
    setValue("terminationClause", parsed.Termination_clause.toLowerCase());
    setTerminationClause(parsed.Termination_clause.toLowerCase());
    setTimeout(() => {
      setValue("noticePeriod", parsed.Notice_Period);
      setValue("terminationNote", parsed.Termination_Note);
    }, 200);

    if (parsed.No_Poach_Clause == "Yes") {
      const scope = String(parsed.No_Poach_Scope || "").toLowerCase();

      if (scope === "global") {
        setValue("noPoachClause", "region");
        setNoPoach("region");
        regions.forEach((region) => {
          const region_name = region.name.toLowerCase();
          if (region_name == scope) {
            setValue("region_id", [region.id]);
          }
        });
        setnoPoachClause("region");
      } else {
        setValue("noPoachClause", scope);
        setNoPoach(scope);

        if (scope === "country") {
          countries.forEach((country) => {
            if (country.name.toLowerCase() === scope) {
              setValue("country_id", country.id);
            }
          });
        } else if (scope === "region") {
          regions.forEach((region) => {
            if (region.name.toLowerCase() === scope) {
              setValue("region_id", [region.id]);
              setValue("region_id", region.id);
            }
          });
        }
        setnoPoachClause(scope);
      }
    }
    setValue("noPoachEndDateRegion", parsed.contractend);
    setValue("contract_file_id", contract_id);
  }, [updata]);

  useEffect(() => {
    if (!parsedData || Object.keys(parsedData).length === 0) return;
    setTimeout(() => {
      const Level_wise_fee_cap_details =  parsedData.Level_wise_fee_cap_details ?? [];

      if (Level_wise_fee_cap_details.length > 0) {
        setRows(Level_wise_fee_cap_details.map((_, i) => i)); // create [0..8]
        Level_wise_fee_cap_details.forEach((item, index) => {
          setValue(`p_level_name.${index}`, item.level_name?.trim() || "");
          setValue(`p_level_rangefrom.${index}`, item.range?.[0] || "");
          setValue(`p_level_rangeto.${index}`, item.range?.[1] || "");
          setValue(`p_level_amount.${index}`, item.fixed_fee || "");
        });
      }
    }, 200);
    companies.forEach((company) => {
      const parsedCompanyName = String(parsedData.company_id || "").trim().toLowerCase();
      const companyName = String(company.name || "").trim().toLowerCase();
      if (companyName.includes(parsedCompanyName) || parsedCompanyName.includes(companyName)) {
        setValue("company_id", company.id);
      }
    });

    clienttypes.forEach((clienttype) => {
      if (
        parsedData.clienttype_id.includes(clienttype.type) ||
        clienttype.type.includes(parsedData.clienttype_id)
      ) {
        setValue("clienttype_id", clienttype.id);
        setClientType(clienttype.id);
        if (clienttype.id === 3) {
          setValue("clientretainertype_id", 1);
          setselectretainertype(1);
        }
      }
    });

    entities.forEach((entity) => {
      const Entity = parsedData.Entity;
      if (Entity == "IND") {
        setValue("entity_id", 9);
      } else if (Entity == entity.name) {
        setValue("entity_id", entity.id);
      }
    });
  }, [parsedData, companies, clienttypes, entities, setValue]); // run only once

  useEffect(() => {
    if (
      !parsedData?.compensation_components ||
      !Array.isArray(compensationComponents) ||
      compensationComponents.length === 0
    ) {
      return;
    }

    const parsedComponents = parsedData.compensation_components;

    // ID 1 and 2 are always selected
    const selectedIds = [1, 2];

    Object.entries(parsedComponents).forEach(
      ([parsedKey, componentData]) => {
        // Only select when AI explicitly says Yes
        if (componentData?.applicable !== "Yes") {
          return;
        }

        const componentCode = parsedComponentToCode[parsedKey];

        if (!componentCode) {
          return;
        }

        const component = compensationComponents.find(
          (item) => item.component_code === componentCode
        );

        if (component && !selectedIds.includes(component.id)) {
          selectedIds.push(component.id);
        }
      }
    );

    setSelectedCompensationComponents(selectedIds);

    // Update react-hook-form value
    setValue("compensation_component_ids", selectedIds, {
      shouldDirty: true,
    });
  }, [parsedData, compensationComponents, setValue]);

  useEffect(() => {
    register("company_id", {
      required: "Please select a company",
    });
  }, [register]);

  const onSubmit = async (data) => {
    if (noPoachClause === "region") {
      if (!SelectedRegion || SelectedRegion.length === 0) {
        // Show error, focus the select2, and stop
        const $selectCountry = $("select[name='region_id']");
        // Focus on the select2 dropdown
        $selectCountry.select2("open");

        return; // Prevent further processing
      }
    } else if (noPoachClause === "country") {
      if (!SelectedCountry || SelectedCountry.length === 0) {
        // Show error, focus the select2, and stop
        const $selectCountry = $("select[name='country_id']");
        // Focus on the select2 dropdown
        $selectCountry.select2("open");

        return; // Prevent further processing
      }
    }

    const formData = new FormData();

    // loop through all keys in data
    Object.keys(data).forEach((key) => {
      const value = data[key];

      if (value instanceof FileList) {
        // if it's a file input (FileList), add first file
        if (value.length > 0) {
          formData.append(key, value[0]);
        }
      } else {
        // otherwise add as a normal field
        formData.append(key, value);
      }
    });

    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/contracts/add_contract`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );
      toastr.success("Contract added successfully!");
      const data = {
        contract_id: response.data.contractid,
        status: "new",
      };
      onClose(data);
      setTimeout(() => {
        navigate("/contract/list");
      }, 1000);
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error submitting contract.");
    } finally {
      setGlobalLoading(false);
    }
  };

  // ############################################################
  const splitSelectChange = (e) => {
    setCount(Number(e.target.value)); // convert string to number
  };

  const retainerTypeSelectChange = (e) => {
    setselectretainertype(e.target.value);
  };
  const feeSelectChange = (e) => {
    setFeeType(e.target.value);
  };
  const clienttypeSelectChange = (e) => {
    setClientType(parseInt(e));
    if(parseInt(e) === 3){
          setValue("clientretainertype_id", 1);
          setselectretainertype(1);
        }
  };
  const feeCapSelectChange = (e) => {
    setFeeCapType(e.target.value);
  };

  const roleNumberChange = (e) => {
    setroleNumber(e.target.value);
  };

  const terminationClauseChange = (e) => {
    setTerminationClause(e.target.value);
  };

  const nopoachChange = (e) => {
    setNoPoach(e.target.value);
    setnoPoachClause(e.target.value);
  };

  useEffect(() => {
    if (noPoachClause === "region") {
      const $select = $("[name='region_id']");
      $select.select2({
        placeholder: "Please Select Regions",
        width: "100%",
      });

      $select.on("change", function () {
        const selectedValue = $(this).val();
        setValue("region_id", selectedValue);
        setSelectedRegion(selectedValue);
      });

      return () => {
        $select.off("change").select2("destroy");
      };
    } else if (noPoachClause === "country") {
      const $select = $("[name='country_id']");
      $select.select2({
        placeholder: "Please Select Countries",
        width: "100%",
      });

      $select.on("change", function () {
        const selectedValue = $(this).val();
        setValue("country_id", selectedValue);
        setSelectedCountry(selectedValue);
      });

      return () => {
        $select.off("change").select2("destroy");
      };
    }
  }, [noPoachClause]);

  // Add Description

  const contractStart = watch("contractstart");
  useEffect(() => {
    if (contractStart) {
      const startDate = new Date(contractStart);
      const endDate = new Date(startDate);
      endDate.setFullYear(endDate.getFullYear() + 1); // add 1 year
      endDate.setDate(endDate.getDate() - 1);

      // Format date as yyyy-mm-dd for input[type=date]
      const formattedEnd = endDate.toISOString().split("T")[0];

      // Set the contractend field value
      setValue("contractend", formattedEnd);
    }
  }, [contractStart, setValue]);

  const getSplitValues = () => {
    return [...Array(Number(splitNum || count))].map((_, i) => {
      const raw = watch(`p_scnt_${i + 1}`) || "";
      const numericValue = parseFloat(raw.toString().replace("%", ""));
      return isNaN(numericValue) ? 0 : numericValue;
    });
  };

  const handleCompensationComponentChange = (componentId, checked) => {
    setSelectedCompensationComponents((prev) => {
      const updated = checked
        ? [...prev, componentId]
        : prev.filter((id) => id !== componentId);

      setValue("compensation_component_ids", updated);

      return updated;
    });
  };

  console.log("Form Errors:", errors);

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div
        className="modal-dialog modal-dialog-centered modal-md add_contract_modal"
        role="document"
        style={{ maxWidth: "950px" }}
      >
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">
                Add Contract
                <span style={{ marginLeft: "20px" }}>
                  <button type="button" className="btn btn-primary my-1 me-2">
                    AGN No.{" "}
                    <span className="badge ms-2 bg-secondary">
                      {data?.new_agn}
                    </span>
                  </button>
                  <input type="hidden" {...register("contract_file_id")} />
                </span>
              </h4>
              <button
                onClick={() => onClose()}
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ textAlign: "left" }}>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Contract Name *</label>
                    <input type="hidden" {...register("agn")} />
                    <input
                      type="text"
                      {...register("contract_name", { required: "required" })}
                      className={`form-control ${errors.contract_name && "is-invalid"}`}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Client Name *</label>
                    <Select
                      options={companies.map((company) => ({
                        value: company.id,
                        label: company.name,
                      }))}
                      value={
                        companies
                          .map((company) => ({
                            value: company.id,
                            label: company.name,
                          }))
                          .find((option) => option.value === watch("company_id")) || null
                      }
                      onChange={(selectedOption) =>
                        setValue("company_id", selectedOption?.value || "", {
                          shouldValidate: true,
                          shouldDirty: true,
                        })
                      }
                      placeholder="Select Company"
                      isSearchable
                    />

                    {errors.company_id && (
                      <div className="text-danger mt-1">
                        {errors.company_id.message}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-4 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Client Type *</label>
                    <select
                      {...register("clienttype_id", {
                        required: "Please select client type",
                      })}
                      onChange={(e) => clienttypeSelectChange(e.target.value)}
                      className={`form-select ${errors.clienttype_id && "is-invalid"}`}
                    >
                      <option value="">Select</option>
                      {clienttypes.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.type}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {clienttype === 3 ? (
                  <div className="col-md-4 col-sm-12">
                    <div className="mb-3">
                      <label className="form-label">Retainer Type *</label>
                      <select
                        {...register("clientretainertype_id", {
                          required: "Please select retainer type",
                        })}
                        onChange={retainerTypeSelectChange}
                        className={`form-select ${errors.clientretainertype_id && "is-invalid"}`}
                      >
                        <option value="">Select</option>
                        {retainertype.map((m) => (
                          <option key={m.id} value={m.id}>
                            {m.type}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="col-md-4 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Entity *</label>
                    <select
                      {...register("entity_id", {
                        required: "Please select entity",
                      })}
                      className={`form-select ${errors.entity_id && "is-invalid"}`}
                    >
                      <option value="">Select</option>
                      {entities.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="row border-bottom mb-3">
                <div className="col-md-3 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Contract Signed</label>
                    <select
                      {...register("contractSigned")}
                      className="form-select"
                    >
                      <option value="0">No</option>
                      <option value="1">Yes</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-3 col-sm-12 ">
                  <label className="form-label">Currency Type *</label>
                  <select {...register("currency_id")} className="form-select">
                    {currency.map((m) => (
                      <option key={m.id} value={m.id}>
                        {m.symbol}
                        {" - "}
                        {m.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Contract Start</label>
                    <div className="input-icon position-relative w-100 me-2">
                      <input
                        type="date"
                        {...register("contractstart", { required: "required" })}
                        className={`datetimepicker form-control ${errors.contractstart && "is-invalid"}`}
                        placeholder="dd/mm/yyyy"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-12">
                  <div className="mb-3">
                    <label className="form-label">Contract End</label>
                    <div className="input-icon position-relative w-100 me-2">
                      <input
                        type="date"
                        {...register("contractend", {
                          required: "required",
                          validate: (value) => {
                            const start = watch("contractstart");
                            if (!start || !value) return true;

                            const startDate = new Date(start);
                            const minEndDate = new Date(startDate);
                            minEndDate.setMonth(minEndDate.getMonth() + 3);
                            const endDate = new Date(value);
                            return (
                              endDate >= minEndDate ||
                              "Contract end must be at least 3 months after contract start"
                            );
                          },
                        })}
                        className={`datetimepicker form-control ${errors.contractend && "is-invalid"}`}
                        placeholder="dd/mm/yyyy"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {clienttype === 3 && selectretainertype != 3 ? (
                <div className="row">
                  <div className="border-bottom mb-3">
                    <h4 className="mb-2">Retainer Breakup</h4>
                    <div className="border rounded p-3 mb-3">
                      <div className="">
                        <div className="row col-md-12">
                          <div className="col-md-3 p-3">
                            <label className="form-label">
                              Number Of Split
                            </label>
                            <select
                              {...register("split_num")}
                              onChange={splitSelectChange}
                              className="form-select"
                            >
                              <option value="1">One</option>
                              <option value="2">Two</option>
                              <option selected={"selected"} value="3">Three</option>
                              <option value="4">Four</option>
                              <option value="5">Five</option>
                              <option value="6">Six</option>
                              <option value="7">Seven</option>
                              <option value="8">Eight</option>
                              <option value="9">Nine</option>
                              <option value="10">Ten</option>
                              <option value="11">Eleven</option>
                            </select>
                          </div>
                          <div className="border rounded p-3 mb-3 col-md-9 row">
                            {Object.values(errors).some(
                              (e) =>
                                e?.message ===
                                "Percentage splits must total 100",
                            ) && (
                              <div className="text-danger mt-2">
                                Percentage-based splits must sum to 100
                              </div>
                            )}
                            <div className="col-md-3">
                              <div className="mb-3">
                                <label className="form-label">
                                  {" "}
                                  Retainer Split *{" "}
                                </label>
                                {[...Array(count)].map((_, i) => (
                                  <div key={i} style={{ marginTop: "5px" }}>
                                    <input
                                      type="text"
                                      {...register(`p_scnt_${i + 1}`, {
                                        required: "required",
                                        validate: {
                                          percentageOrFixed: () => {
                                            if (
                                              Number(clientRetainerTypeId) !== 1
                                            ) {
                                              return true;
                                            }
                                            const values = getSplitValues();
                                            const hasPercentage = values.some(
                                              (v) => v > 0 && v < 100,
                                            );
                                            if (hasPercentage) {
                                              const sum = values.reduce(
                                                (a, b) => a + b,
                                                0,
                                              );
                                              if (sum !== 100) {
                                                return "Percentage splits must total 100";
                                              }
                                            }
                                            return true;
                                          },
                                        },
                                        pattern: {
                                          value:
                                            /^(?!\.)(?!.*\.\.)(\d+(\.\d+)?%?)?$/,
                                          message:
                                            "Only numbers, decimal, and % are allowed",
                                        },
                                      })}
                                      key={i}
                                      placeholder={`split ${i + 1}`}
                                      className={`form-control ${
                                        errors[`p_scnt_${i + 1}`] &&
                                        "is-invalid"
                                      }`}
                                      onInput={(e) => {
                                        // remove invalid characters except decimal point
                                        e.target.value = e.target.value.replace(
                                          /[^0-9.%]/g,
                                          "",
                                        );
                                        // remove extra decimals
                                        const parts = e.target.value.split(".");
                                        if (parts[1]?.length > 3) {
                                          e.target.value =
                                            parts[0] +
                                            "." +
                                            parts[1].slice(0, 3);
                                        }
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                            <div className="col-md-9">
                              <div className="row">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Give details on when is the Retainer to be
                                    charged *
                                  </label>
                                  {[...Array(count)].map((_, i) => (
                                    <div key={i} style={{ marginTop: "5px" }}>
                                      <input
                                        type="text"
                                        {...register(`p_scnt_note_${i + 1}`, {
                                          required: "required",
                                        })}
                                        key={i}
                                        placeholder={`split notes ${i + 1}`}
                                        className={`form-control ${errors[`p_scnt_note_${i + 1}`] && "is-invalid"}`}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="row">
                <div className="border-bottom mb-3">
                  <h4 className="mb-2">Fees Details</h4>
                  <div className="border rounded p-3 mb-3">
                    <div className="">
                      <div className="row col-md-12">
                        <div className="col-md-3 p-3">
                          <label className="form-label">Fee Type</label>
                          <select
                            {...register("fee_type")}
                            onChange={feeSelectChange}
                            className="form-select"
                          >
                            <option selected value="RoleWise">
                              RoleWise
                            </option>
                            <option value="LevelWise">LevelWise</option>
                          </select>
                        </div>
                        {feetype === "RoleWise" ? (
                          <div className="border rounded p-3 mb-3 col-md-9 row">
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="form-label d-block text-wrap">
                                  Pricing Conditions → Fee tiers based on number
                                  of roles (e.g., 2 roles at 20%, 3 roles at
                                  25%, remaining at 30% = 3 conditions). *
                                </label>
                                <select
                                  {...register("role_number")}
                                  onChange={roleNumberChange}
                                  className="form-select"
                                >
                                  <option selected value="single-condition">
                                    One
                                  </option>
                                  <option value="two-condition">Two</option>
                                  <option value="three-condition">Three</option>
                                </select>
                              </div>
                            </div>
                            {roleNumber === "single-condition" ? (
                              <div className="col-md-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Fee Percentage (flat or %)
                                  </label>
                                  <input
                                    {...register(`type_one_fee`, {
                                      required: "required",
                                      pattern: {
                                        value:
                                          /^(?!\.)(?!.*\.\.)(\d+(\.\d+)?%?)?$/,
                                        message:
                                          "Only numbers, decimal, and % are allowed",
                                      },
                                    })}
                                    key="type_one_fee"
                                    type="text"
                                    placeholder={`i.e. 25% or 2000000 (Flat Fee)`}
                                    className={`form-control ${
                                      errors.type_one_fee && "is-invalid"
                                    }`}
                                    onInput={(e) => {
                                      // remove invalid characters except decimal point
                                      e.target.value = e.target.value.replace(
                                        /[^0-9.%]/g,
                                        "",
                                      );
                                      // remove extra decimals
                                      const parts = e.target.value.split(".");
                                      if (parts[1]?.length > 3) {
                                        e.target.value =
                                          parts[0] + "." + parts[1].slice(0, 3);
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            ) : (
                              <>
                                {roleNumber === "two-condition" ? (
                                  <>
                                    <div className="col-md-12 row">
                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <label className="form-label">
                                            No of Roles
                                          </label>
                                          <input
                                            {...register(`type_one_number`, {
                                              required: "required",
                                            })}
                                            key="type_one_number"
                                            type="number"
                                            min={1}
                                            className={`form-control ${
                                              errors.type_one_number &&
                                              "is-invalid"
                                            }`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <label className="form-label">
                                            Fee (falt fee or %)
                                          </label>
                                          <input
                                            {...register(`type_one_fee`, {
                                              required: "required",
                                              pattern: {
                                                value:
                                                  /^(?!\.)(?!.*\.\.)(\d+(\.\d+)?%?)?$/,
                                                message:
                                                  "Only numbers, decimal, and % are allowed",
                                              },
                                            })}
                                            key="type_one_fee"
                                            placeholder={`eg. 25% or 2000000 (Flat Fee)`}
                                            type="text"
                                            className={`form-control ${
                                              errors.type_one_fee &&
                                              "is-invalid"
                                            }`}
                                            onInput={(e) => {
                                              // remove invalid characters except decimal point
                                              e.target.value =
                                                e.target.value.replace(
                                                  /[^0-9.%]/g,
                                                  "",
                                                );
                                              // remove extra decimals
                                              const parts =
                                                e.target.value.split(".");
                                              if (parts[1]?.length > 3) {
                                                e.target.value =
                                                  parts[0] +
                                                  "." +
                                                  parts[1].slice(0, 3);
                                              }
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-12 row">
                                      <div className="col-md-6">
                                        <div
                                          className="mb-3 border border-dark text-center"
                                          style={{
                                            borderColor:
                                              "rgba(221, 231, 241, 0.4)",
                                          }}
                                        >
                                          <label className="form-label p-0 mt-2 mb-1">
                                            Remaining Roles
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <input
                                            {...register(`type_two_fee`, {
                                              //required: "required",
                                              pattern: {
                                                value:
                                                  /^(?!\.)(?!.*\.\.)(\d+(\.\d+)?%?)?$/,
                                                message:
                                                  "Only numbers, decimal, and % are allowed",
                                              },
                                            })}
                                            key="type_two_fee"
                                            type="text"
                                            placeholder={`eg. 25% or 2000000 (Flat Fee)`}
                                            className={`form-control ${
                                              errors.type_two_fee &&
                                              "is-invalid"
                                            }`}
                                            onInput={(e) => {
                                              // remove invalid characters except decimal point
                                              e.target.value =
                                                e.target.value.replace(
                                                  /[^0-9.%]/g,
                                                  "",
                                                );
                                              // remove extra decimals
                                              const parts =
                                                e.target.value.split(".");
                                              if (parts[1]?.length > 3) {
                                                e.target.value =
                                                  parts[0] +
                                                  "." +
                                                  parts[1].slice(0, 3);
                                              }
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="col-md-12 row">
                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <label className="form-label">
                                            No of Roles
                                          </label>
                                          <input
                                            {...register(`type_one_number`, {
                                              required: "required",
                                            })}
                                            key="type_one_number"
                                            type="number"
                                            min={1}
                                            className={`form-control ${
                                              errors.type_one_number &&
                                              "is-invalid"
                                            }`}
                                          />
                                          <input
                                            {...register(`type_two_number`, {
                                              required: "required",
                                            })}
                                            key="type_two_number"
                                            type="number"
                                            min={1}
                                            className={`form-control ${
                                              errors.type_two_number &&
                                              "is-invalid"
                                            } mt-1`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <label className="form-label">
                                            Fee (falt fee or %)
                                          </label>
                                          <input
                                            {...register(`type_one_fee`, {
                                              required: "required",
                                              pattern: {
                                                value:
                                                  /^(?!\.)(?!.*\.\.)(\d+(\.\d+)?%?)?$/,
                                                message:
                                                  "Only numbers, decimal, and % are allowed",
                                              },
                                            })}
                                            key="type_one_fee"
                                            type="text"
                                            placeholder={`eg. 25% or 2000000 (Flat Fee)`}
                                            className={`form-control ${
                                              errors.type_one_fee &&
                                              "is-invalid"
                                            }`}
                                            onInput={(e) => {
                                              // remove invalid characters except decimal point
                                              e.target.value =
                                                e.target.value.replace(
                                                  /[^0-9.%]/g,
                                                  "",
                                                );
                                              // remove extra decimals
                                              const parts =
                                                e.target.value.split(".");
                                              if (parts[1]?.length > 3) {
                                                e.target.value =
                                                  parts[0] +
                                                  "." +
                                                  parts[1].slice(0, 3);
                                              }
                                            }}
                                          />
                                          <input
                                            {...register(`type_two_fee`, {
                                              required: "required",
                                              pattern: {
                                                value:
                                                  /^(?!\.)(?!.*\.\.)(\d+(\.\d+)?%?)?$/,
                                                message:
                                                  "Only numbers, decimal, and % are allowed",
                                              },
                                            })}
                                            key="type_two_fee"
                                            type="text"
                                            placeholder={`eg. 25% or 2000000 (Flat Fee)`}
                                            className={`form-control ${
                                              errors.type_two_fee &&
                                              "is-invalid"
                                            } mt-1`}
                                            onInput={(e) => {
                                              // remove invalid characters except decimal point
                                              e.target.value =
                                                e.target.value.replace(
                                                  /[^0-9.%]/g,
                                                  "",
                                                );
                                              // remove extra decimals
                                              const parts =
                                                e.target.value.split(".");
                                              if (parts[1]?.length > 3) {
                                                e.target.value =
                                                  parts[0] +
                                                  "." +
                                                  parts[1].slice(0, 3);
                                              }
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-12 row">
                                      <div className="col-md-6">
                                        <div
                                          className="mb-3 border border-dark text-center"
                                          style={{
                                            borderColor:
                                              "rgba(221, 231, 241, 0.4)",
                                          }}
                                        >
                                          <label className="form-label p-0 mt-2 mb-1">
                                            Remaining Roles
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="mb-3">
                                          <input
                                            {...register(`type_three_fee`, {
                                              //required: "required",
                                              pattern: {
                                                value:
                                                  /^(?!\.)(?!.*\.\.)(\d+(\.\d+)?%?)?$/,
                                                message:
                                                  "Only numbers, decimal, and % are allowed",
                                              },
                                            })}
                                            key="type_three_fee"
                                            type="text"
                                            placeholder={`eg. 25% or 2000000 (Flat Fee)`}
                                            className={`form-control ${
                                              errors.type_three_fee &&
                                              "is-invalid"
                                            }`}
                                            onInput={(e) => {
                                              // remove invalid characters except decimal point
                                              e.target.value =
                                                e.target.value.replace(
                                                  /[^0-9.%]/g,
                                                  "",
                                                );
                                              // remove extra decimals
                                              const parts =
                                                e.target.value.split(".");
                                              if (parts[1]?.length > 3) {
                                                e.target.value =
                                                  parts[0] +
                                                  "." +
                                                  parts[1].slice(0, 3);
                                              }
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        ) : (
                          <div className="border rounded p-3 mb-3 col-md-9 row">
                            <div className="add-fields-info">
                              {rows.map((row, index) => (
                                <div key={index} className="row">
                                  <div className="col-md-3">
                                    {index === 0 && (
                                      <label className="form-label">
                                        Level Name *
                                      </label>
                                    )}
                                    <input
                                      {...register(`p_level_name.${index}`, {
                                        required: "required",
                                      })}
                                      type="text"
                                      className={`form-control ${
                                        errors.p_level_name?.[index]
                                          ? "is-invalid"
                                          : ""
                                      } ${index > 0 && "mt-1"}`}
                                    />
                                  </div>
                                  <div className="col-md-3">
                                    {index === 0 && (
                                      <label className="form-label">
                                        Comp Range From
                                      </label>
                                    )}
                                    <input
                                      {...register(
                                        `p_level_rangefrom.${index}`,
                                        // {
                                        //   required: "required",
                                        // }
                                      )}
                                      type="text"
                                      className={`form-control ${
                                        errors.p_level_rangefrom?.[index]
                                          ? "is-invalid"
                                          : ""
                                      } ${index > 0 && "mt-1"}`}
                                    />
                                  </div>
                                  <div className={`col-md-3`}>
                                    {index === 0 && (
                                      <label className="form-label">
                                        Comp Range To
                                      </label>
                                    )}
                                    <input
                                      {...register(
                                        `p_level_rangeto.${index}`,
                                        //   {
                                        //   required: "required",
                                        // }
                                      )}
                                      type="text"
                                      className={`form-control ${
                                        errors.p_level_rangeto?.[index]
                                          ? "is-invalid"
                                          : ""
                                      } ${index > 0 && "mt-1"}`}
                                    />
                                  </div>
                                  <div
                                    className={`col-md-3 ${
                                      index > 2 && "d-flex"
                                    }`}
                                  >
                                    {index === 0 && (
                                      <label className="form-label">
                                        Fee (Flat fee or %)
                                      </label>
                                    )}
                                    <input
                                      {...register(`p_level_amount.${index}`, {
                                        required: "required",
                                      })}
                                      type="text"
                                      className={`form-control ${
                                        errors.p_level_amount?.[index]
                                          ? "is-invalid"
                                          : ""
                                      } ${index > 0 && "mt-1 myInput-130px"}`}
                                    />
                                    {index > 2 && (
                                      <button
                                        type="button"
                                        className="btn btn-icon btn-sm ms-1 mt-2"
                                        onClick={() => {
                                          unregister(`p_level_name.${index}`);
                                          unregister(
                                            `p_level_rangefrom.${index}`,
                                          );
                                          unregister(
                                            `p_level_rangeto.${index}`,
                                          );
                                          unregister(`p_level_amount.${index}`);
                                          setRows((prev) =>
                                            prev.filter((i) => i !== index),
                                          );
                                        }}
                                      >
                                        <i className="far fa-trash-alt text-danger"></i>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                            <a
                              href="javascript:void(0);"
                              onClick={(e) => handleAddMore()}
                              className="text-primary fw-medium d-flex align-items-center"
                            >
                              <i className="ti ti-plus me-2"></i>Add New
                            </a>
                          </div>
                        )}
                      </div>
                      <div className="row col-md-12 border-bottom mb-3">
                        <div className="col-md-4 p-3">
                          <label className="form-label">
                            Expense (% or flat fee){!disableExpense && "*"}
                          </label>
                          <input
                            {...register("expensePercent", {
                              required: !disableExpense && "required",
                            })}
                            key="expensePercent"
                            type="text"
                            placeholder="eg. 10% or 200000"
                            className={`form-control ${
                              errors.expensePercent && "is-invalid"
                            }`}
                            disabled={disableExpense}
                            value={
                              disableExpense ? "On actual expense" : undefined
                            }
                            onChange={(e) =>
                              !disableExpense &&
                              setValue("expensePercent", e.target.value)
                            }
                          />
                          {errors.expensePercent && (
                            <div className="invalid-feedback">
                              {errors.expensePercent.message}
                            </div>
                          )}
                        </div>

                        <div className="col-md-4 p-3 d-flex align-items-center">
                          <input
                            type="checkbox"
                            id="disableExpense"
                            checked={disableExpense}
                            onChange={() => {
                              setDisableExpense((prev) => {
                                const newValue = !prev;
                                if (newValue) {
                                  // Set field to "ON Actual Expense" when disabled
                                  setValue(
                                    "expensePercent",
                                    "On actual expense",
                                  );
                                  clearErrors("expensePercent");
                                } else {
                                  // Clear field when re-enabled
                                  setValue("expensePercent", "");
                                }
                                return newValue;
                              });
                            }}
                          />
                          <label htmlFor="disableExpense" className="ms-2">
                            On actual expense
                          </label>
                        </div>
                      </div>

                      <div className="row col-md-12">
                        <div className="col-md-3 p-3">
                          <label className="form-label">Fee Cap Type</label>
                          <select
                            {...register("fee_cap_type")}
                            onChange={feeCapSelectChange}
                            className="form-select"
                          >
                            <option value="NA">NA</option>
                            <option value="Flat">Flat</option>
                            <option value="LevelWise">LevelWise</option>
                          </select>
                        </div>
                        {feecaptype === "Flat" ? (
                          <div className="p-3 mb-3 col-md-9 row">
                            <div className="mb-3 col-md-4">
                              <label className="form-label">
                                Fee Cap Amount
                              </label>
                              <input
                                {...register(`fee_cap_amount`)}
                                key="fee_cap_amount"
                                type="text"
                                placeholder={`Max. fee cap`}
                                className="form-control"
                              />
                            </div>
                            <div className="mb-3 col-md-4">
                              <label className="form-label">
                                Base Fee Cap Amount
                              </label>
                              <input
                                {...register(`base_fee_cap_amount`)}
                                key="base_fee_cap_amount"
                                type="text"
                                placeholder={`Min. fee cap`}
                                className="form-control"
                              />
                            </div>
                          </div>
                        ) : feecaptype === "LevelWise" ? (
                          <div className="border rounded p-3 mb-3 col-md-9 row">
                            <div className="add-fields-info">
                              {rows.map((row, index) => (
                                <div key={index} className="row">
                                  <div className="col-md-6">
                                    {index === 0 && (
                                      <label className="form-label">
                                        {" "}
                                        Level Name *
                                      </label>
                                    )}
                                    <input
                                      {...register(`p_levelcap_name.${index}`, {
                                        required: "required",
                                      })}
                                      type="text"
                                      className={`form-control ${
                                        errors.p_level_name?.[index]
                                          ? "is-invalid"
                                          : ""
                                      } ${index > 0 && "mt-1"}`}
                                    />
                                  </div>
                                  <div
                                    className={`col-md-3 ${
                                      index > 2 && "d-flex"
                                    }`}
                                  >
                                    {index === 0 && (
                                      <label className="form-label">
                                        {" "}
                                        Level Cap Amount *
                                      </label>
                                    )}
                                    <input
                                      {...register(
                                        `p_levelcap_amount.${index}`,
                                        { required: "required" },
                                      )}
                                      type="text"
                                      className={`form-control ${
                                        errors.p_level_amount?.[index]
                                          ? "is-invalid"
                                          : ""
                                      } ${index > 0 && "mt-1 myInput-130px"}`}
                                    />
                                    {index > 2 && (
                                      <button
                                        type="button"
                                        className="btn btn-icon btn-sm ms-1 mt-2"
                                        onClick={() => {
                                          unregister(
                                            `p_levelcap_name.${index}`,
                                          );
                                          unregister(
                                            `p_levelcap_amount.${index}`,
                                          );
                                          setRows((prev) =>
                                            prev.filter((i) => i !== index),
                                          );
                                        }}
                                      >
                                        <i className="far fa-trash-alt text-danger"></i>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                            <a
                              href="javascript:void(0);"
                              onClick={(e) => handleAddMore()}
                              className="text-primary fw-medium d-flex align-items-center"
                            >
                              <i className="ti ti-plus me-2"></i>Add New
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {selectretainertype == 1 ? (
              <div className="row">
                <div className="border-bottom mb-3">
                  <h4 className="mb-2">Billable Compensation Components</h4>
                  <div className="border rounded p-3 mb-3">
                    {["compensation", "other_cash", "equity"].map((category) => {
                      const categoryComponents = compensationComponents.filter(
                        (component) => component.category === category
                      );

                      if (categoryComponents.length === 0) {
                        return null;
                      }

                      const categoryTitle = category === "compensation" ? "Compensation" : category === "other_cash" ? "Other Cash Components in Year 1" : "Equity Compensation";

                      return (
                        <div key={category} className="mb-4">
                          <h5 className="mb-3">{categoryTitle}</h5>
                          <div className="row">
                            {categoryComponents.map((component) => (
                              <div className="col-md-6 col-lg-4 mb-3" key={component.id}>
                                <div className="form-check">
                                  <input
                                      type="checkbox"
                                      id={`compensation_${component.id}`}
                                      value={component.id}
                                      checked={selectedCompensationComponents.includes(component.id)}
                                      onChange={(e) =>
                                        handleCompensationComponentChange(
                                          Number(e.target.value),
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <input type="hidden" {...register("compensation_component_ids")} />

                                  <label className="form-check-label ms-2" htmlFor={`compensation_${component.id}`}>
                                    {component.component_name}
                                  </label>

                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    })}

                  </div>
                </div>
              </div>
             ) : (
                ""
              )}
              <div className="row">
                <div className="col-sm-12 row">
                  <div className="col-md-3 mb-3">
                    <label className="form-label">
                      Resignation Replacement{" "}
                    </label>
                    <select
                      {...register("candidateRegPeriod")}
                      className="form-select"
                    >
                      <option value="1 months">1 months</option>
                      <option value="3 months">3 months</option>
                      <option value="6 months" selected>
                        6 months
                      </option>
                      <option value="9 months">9 months</option>
                      <option value="12 months">12 months</option>
                      <option value="16 months">16 months</option>
                      <option value="18 months">18 months</option>
                      <option value="None">None</option>
                    </select>
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label">
                      Candidate Profile Validity
                    </label>
                    <select
                      {...register("candidateProfileValidity")}
                      className="form-select"
                    >
                      <option value="1 months">1 months</option>
                      <option value="3 months">3 months</option>
                      <option value="6 months">6 months</option>
                      <option value="9 months">9 months</option>
                      <option value="12 months" selected>
                        12 months
                      </option>
                      <option value="16 months">16 months</option>
                      <option value="18 months">18 months</option>
                      <option value="24 months">24 months</option>
                      <option value="None">None</option>
                    </select>
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Invoice due in</label>
                    <select
                      {...register("invoice_due_in")}
                      className="form-select"
                    >
                      <option value="7">7</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                      <option value="30" selected>30</option>
                      <option value="45">45</option>
                      <option value="60">60</option>
                      <option value="null">None</option>
                    </select>
                  </div>
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Profile Validity Fee</label>
                    <input
                      {...register(`profileValidityFee`)}
                      key="profileValidityFee"
                      type="text"
                      className={`form-control ${
                        errors.profileValidityFee && "is-invalid"
                      }`}
                    />
                  </div>
                </div>
                <div className="col-sm-12 row">
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Termination Clause *</label>
                    <select
                      {...register("terminationClause")}
                      onChange={terminationClauseChange}
                      className="form-select"
                    >
                      <option value="no" selected>
                        No
                      </option>
                      <option value="yes">Yes</option>
                    </select>
                  </div>
                  {terminationClause === "yes" ? (
                    <>
                      <div className="col-md-3 mb-3">
                        <label className="form-label">Notice Period *</label>
                        <input
                          {...register(`noticePeriod`, {
                            required: "required",
                          })}
                          key="noticePeriod"
                          type="text"
                          className={`form-control ${
                            errors.noticePeriod && "is-invalid"
                          }`}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Termination Note *</label>
                        <input
                          {...register(`terminationNote`, {
                            required: "required",
                          })}
                          key="terminationNote"
                          type="text"
                          className={`form-control ${
                            errors.terminationNote && "is-invalid"
                          }`}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-sm-12 row">
                  <div className="col-md-3 mb-3">
                    <label className="form-label">No Poach Clause *</label>
                    <select
                      {...register("noPoachClause")}
                      onChange={nopoachChange}
                      className="form-select"
                    >
                      <option value="no" selected>
                        No
                      </option>
                      <option value="country">Country</option>
                      <option value="region">Region</option>
                    </select>
                  </div>
                  {nopoach === "country" ? (
                    <>
                      <div className="col-md-3 mb-3">
                        <label className="form-label">No Poach Country *</label>
                        <select
                          {...register("country_id", { required: "Required" })}
                          multiple
                          className={`form-select select2`}
                        >
                          {countries.map((m) => (
                            <option key={m.id} value={m.id}>
                              {m.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-3 mb-3">
                        <label className="form-label">
                          No Poach End Date *
                        </label>
                        <div className="input-icon position-relative w-100 me-2">
                          <input
                            {...register(`noPoachEndDateCountry`, {
                              required: "required",
                            })}
                            type="date"
                            className={`datetimepicker form-control ${
                              errors.noPoachEndDateCountry && "is-invalid"
                            }`}
                            placeholder="dd/mm/yyyy"
                          />
                        </div>
                      </div>
                    </>
                  ) : nopoach === "region" ? (
                    <>
                      <div className="col-md-3 mb-3">
                        <label className="form-label">No Poach Region *</label>
                        <select
                          {...register("region_id")}
                          multiple
                          className="form-select select2"
                        >
                          {regions.map((m) => (
                            <option key={m.id} value={m.id}>
                              {m.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-3 mb-3">
                        <label className="form-label">
                          No Poach End Date *
                        </label>
                        <div className="input-icon position-relative w-100 me-2">
                          <input
                            {...register(`noPoachEndDateRegion`, {
                              required: "required",
                            })}
                            type="date"
                            className={`datetimepicker form-control ${
                              errors.noPoachEndDateRegion && "is-invalid"
                            }`}
                            placeholder="dd/mm/yyyy"
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-sm-12 row">
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Comments</label>
                    <input
                      {...register(`comments`)}
                      key="comments"
                      type="text"
                      className={`form-control ${
                        errors.comments && "is-invalid"
                      }`}
                    />
                  </div>
                  {!parsedData ||
                    (Object.keys(parsedData).length === 0 && (
                      <div className="col-md-4 mb-3">
                        <label className="form-label">Contract File</label>
                        <input
                          type="file"
                          className="form-control"
                          accept="application/pdf"
                          {...register("file_name", {
                            validate: (files) => {
                              if (!files || files.length === 0) return true;
                              const file = files[0];
                              return (
                                (file.type === "application/pdf" &&
                                  file.name.toLowerCase().endsWith(".pdf")) ||
                                "Only PDF files are allowed"
                              );
                            },
                          })}
                        />
                        {errors?.file_name && (
                          <small className="text-danger">
                            {errors.file_name.message}
                          </small>
                        )}
                      </div>
                    ))}
                  <div className="col-md-4 mb-3">
                    <label className="form-label">DPA File</label>
                    <input
                      type="file"
                      className="form-control"
                      {...register("file_name1")}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                onClick={() => onClose()}
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary ms-2">
                Add Contract
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddContract;
